<template>
    <div class="form-value">
        <div class="simple-row" v-if="!thisShowView">
            <div class="left">
                <swb-file-upload fileGroup="file-misc" fileFor="purch" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
            </div>
        </div>
        <ul class="file-area input clearfix" v-if="fileInfo.fileUuid != null">
            <li class="file-content clearfix" style="height: 200px;">
                <swb-file-item :fileUuid="fileInfo.fileUuid" :fileBrowseUrl="fileInfo.signFileBrowseUrl" :fileDownloadUrl="fileInfo.fileDownLoadUrl" :fileMd5="fileInfo.fileMd5" :deletable="!thisShowView" :onDelete="deleteFile"></swb-file-item>
                <el-input class="width-2x" :disabled="thisShowView" v-model="fileInfo.desc" placeholder="请输入内容"></el-input>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    import goodsOrderApi from '../../api/goodsOrder'

    export default {
        name: 'swb-goods-order-sign-confirmed-info',
        desc: '商品订单签字确认-上传PDF',
        props: ['orderId', 'showView'],
        data: function () {
            return {
                goodsOrder: {},
                fileInfo: {},
                thisShowView: false,
            }
        },
        created: function () {
            this.thisShowView = Utils.isTrue(this.showView);
            //
            this.getGoodsOrderById(this.orderId);
        },
        methods: {
            getGoodsOrderById: function (orderId) {
                let self = this;
                let postData = {};
                postData.id = orderId;
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        let goodsOrder = result.data;
                        let fileInfo = {};
                        fileInfo.fileUuid = goodsOrder.signFileUuid;
                        fileInfo.signFileBrowseUrl = goodsOrder.signFileBrowseUrl;
                        fileInfo.fileDownLoadUrl = goodsOrder.signFileBrowseUrl;
                        fileInfo.fileMd5 = goodsOrder.signFileMd5;
                        fileInfo.desc = goodsOrder.signFileRemark;
                        self.fileInfo = Utils.merge({}, fileInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let fileInfo = files[i];
                        let item = {
                            fileUuid: fileInfo.fileUuid,
                            desc: fileInfo.fileName,
                            fileExtName: fileInfo.fileExtName,
                            signFileBrowseUrl: fileInfo.fileBrowseUrl,
                            fileDownLoadUrl: fileInfo.fileBrowseUrl,
                            fileMd5: fileInfo.fileMd5,
                        };
                        self.fileInfo = Utils.merge({}, item);
                    }
                } else {
                    this.$message.success(result.message);
                }
            },
            deleteFile: function () {
                this.fileInfo = {};
            },
            getDlgResult: function () {
                let resultInfo = {
                    type: 'warn'
                };
                let fileInfo = this.fileInfo || {};
                if(Utils.isNoB(fileInfo.fileUuid)) {
                    resultInfo.message = '请上传附件信息';
                    return resultInfo;
                }
                if(!Utils.isNoB(fileInfo.signFileRemark) && fileInfo.signFileRemark.length > 90) {
                    resultInfo.message = '文件描述不可超过90个字符';
                    return resultInfo;
                }
                resultInfo.type = 'info';
                resultInfo.data = Utils.merge({}, fileInfo);
                return resultInfo;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderSignConfirmedInfo.vue